import { Routes, Route } from 'react-router-dom';
import { RequireAuth } from './auth/RequireAuth';
import AppChrome from './components/layout/AppChrome';
import LoginPage from './pages/LoginPage';
import OperatePage from './pages/OperatePage';
import LeadDetailPage from './pages/LeadDetailPage';
import PipelinePage from './pages/PipelinePage';
import LibraryPage from './pages/LibraryPage';
import TodayPage from './pages/TodayPage';
import ChatPage from './pages/ChatPage';
import ImportPage from './pages/ImportPage';
import TemplatesPage from './pages/TemplatesPage';
import DatosPage from './pages/DatosPage';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/operate"
        element={
          <RequireAuth>
            <AppChrome>
              <OperatePage />
            </AppChrome>
          </RequireAuth>
        }
      />
      <Route
        path="/pipeline"
        element={
          <RequireAuth>
            <AppChrome>
              <PipelinePage />
            </AppChrome>
          </RequireAuth>
        }
      />
      <Route
        path="/library"
        element={
          <RequireAuth>
            <AppChrome>
              <LibraryPage />
            </AppChrome>
          </RequireAuth>
        }
      />
      <Route
        path="/today"
        element={
          <RequireAuth>
            <AppChrome>
              <TodayPage />
            </AppChrome>
          </RequireAuth>
        }
      />
      <Route
        path="/leads/:id"
        element={
          <RequireAuth>
            <AppChrome>
              <LeadDetailPage />
            </AppChrome>
          </RequireAuth>
        }
      />
      <Route
        path="/chat"
        element={
          <RequireAuth>
            <AppChrome>
              <ChatPage />
            </AppChrome>
          </RequireAuth>
        }
      />
      <Route
        path="/import"
        element={
          <RequireAuth>
            <AppChrome>
              <ImportPage />
            </AppChrome>
          </RequireAuth>
        }
      />
      <Route
        path="/templates"
        element={
          <RequireAuth>
            <AppChrome>
              <TemplatesPage />
            </AppChrome>
          </RequireAuth>
        }
      />
      <Route
        path="/datados"
        element={
          <RequireAuth>
            <AppChrome>
              <DatosPage />
            </AppChrome>
          </RequireAuth>
        }
      />
    </Routes>
  );
}
